import React, { Component } from "react";

export class Wallets extends Component {
  static displayName = Wallets.name;

  render() {
    return (
      <div className="mbox">
        <h4 className="text-center">
          <i className="bi bi-wallet" style={{ color: "red" }}></i>
          <span className="m-2"> Bitcoin Wallets</span>
        </h4>
        <hr />
        <div>
          <div style={{ color: "green" }} title="Bitcoin hardware wallet is a physical, offline device that stores your private keys, providing a high level of security by isolating them from internet-connected devices">Hardware Wallets:</div>
          <table className="" style={{ width: "100%" }}>
            <tbody>
            <tr>
              <td style={{ width: "50%" }}>
                <ul>
                  <li>
                    <a href="https://blockstream.com/jade/" target="_blank">
                      Blockstream Jade
                    </a>
                  </li>
                  <li>
                    <a href="https://foundationdevices.com/" target="_blank">
                      Passport Foundation
                    </a>
                    </li>
                    <li>
                        <a href="https://seedsigner.com/" target="_blank">
                            Seed Signer
                        </a>
                    </li>
                </ul>
              </td>
              <td style={{ width: "50%" }}>
                <ul>
                    <li>
                        <a href="https://trezor.io/" target="_blank">
                            Trezor
                        </a>
                    </li>
                    <li>
                        <a href="https://selfcustody.github.io/krux/" target="_blank">
                            Krux
                        </a>
                    </li>
                  <li>
                    <a href="https://www.ledger.com/" target="_blank">
                      Ledger
                    </a>
                  </li>
                </ul>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div style={{ color: "green" }} title="Bitcoin software wallet is a software application that runs on a computer or smartphone where private keys are stored. Software wallets (hot wallets) tend to be less secure than hardware wallets (cold wallets) because they run on internet-connected devices">Software Wallets:</div>
        <table className="" style={{ width: "80%", marginLeft: "20px" }}>
          <tbody>
          <tr>
            <td style={{ width: "50%", paddingLeft: "10px" }}>
              Bitcoin Wallets:
            </td>
            <td style={{ width: "50%", paddingLeft: "10px" }}>
              Lightning/Liquid:
            </td>
          </tr>
          <tr>
            <td>
              <ul>
                <li>
                  <a href="https://sparrowwallet.com/" target="_blank">
                    Sparrow
                  </a>
                </li>
                <li>
                    <a href="https://electrum.org/" target="_blank">
                        Electrum
                    </a>
                </li>
                <li>
                  <a href="https://bluewallet.io/" target="_blank">
                    Blue Wallet
                  </a>
                </li>
                <li>
                    <a href="https://nunchuk.io/" target="_blank">
                        Nunchuk
                    </a>
                </li>
                <li>
                  <a href="https://www.exodus.com/" target="_blank">
                    Exodus Wallet
                  </a>
                </li>
              </ul>
            </td>
            <td>
            <ul>
                <li>
                    <a href="https://www.walletofsatoshi.com/" target="_blank">
                        Wallet of Satoshi (C/NC)
                    </a>
                </li>
                <li>
                  <a href="https://breez.technology/" target="_blank">
                    Breez (NC)
                  </a>
                </li>
                <li>
                  <a href="https://phoenix.acinq.co/" target="_blank">
                    Phoenix (NC)
                  </a>
                </li>
                <li>
                    <a href="https://aqua.net/" target="_blank">
                    Aqua Wallet 
                    </a>
                </li>
              </ul>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    );
  }
}
